import { Popconfirm, Switch } from "antd"
import { useState } from "react"

import { useThemeContext } from "#contexts/ThemeContextProvider"

/**
 * Green means parents get it. Turning it off unshares. Notes, photos, and
 * Story Time use the same switch.
 */
export const ReviewShareSwitch = ({
  shared,
  loading = false,
  disabled = false,
  onToggle,
  testId = "sr-share-switch",
  ariaLabel,
  momentId,
  storyTimeId,
  artworkId,
  similar,
}: {
  shared: boolean
  loading?: boolean
  disabled?: boolean
  onToggle: () => void
  testId?: string
  ariaLabel?: string
  momentId?: string
  storyTimeId?: string
  artworkId?: string
  similar?: boolean
}) => {
  const theme = useThemeContext()
  return (
    <Switch
      data-testid={testId}
      data-shared={shared ? "true" : "false"}
      data-moment-id={momentId}
      data-story-time-id={storyTimeId}
      data-artwork-id={artworkId}
      data-similar={
        similar === undefined ? undefined : similar ? "true" : "false"
      }
      size="small"
      checked={shared}
      loading={loading}
      disabled={disabled}
      aria-label={ariaLabel ?? (shared ? "Unshare" : "Share with parents")}
      onChange={() => onToggle()}
      style={{
        flex: "0 0 auto",
        backgroundColor: shared ? theme.eric.green : undefined,
      }}
    />
  )
}

/**
 * A similar moment asks first, and still shares when confirmed.
 */
const MomentShareSwitch = ({
  momentId,
  shared,
  loading,
  disabled,
  similar,
  onToggle,
}: {
  momentId: string
  shared: boolean
  loading: boolean
  disabled: boolean
  similar: boolean
  onToggle: () => void
}) => {
  const [confirming, setConfirming] = useState(false)
  const askFirst = similar && !shared
  return (
    <Popconfirm
      open={askFirst && confirming}
      onOpenChange={(next) => {
        if (!next) setConfirming(false)
      }}
      title="This looks similar to an earlier comment for this kid. Share anyway?"
      okText="Share"
      onConfirm={() => {
        setConfirming(false)
        onToggle()
      }}
      onCancel={() => setConfirming(false)}
    >
      <span>
        <ReviewShareSwitch
          momentId={momentId}
          shared={shared}
          loading={loading}
          disabled={disabled}
          similar={similar}
          onToggle={() => {
            if (askFirst) {
              setConfirming(true)
              return
            }
            onToggle()
          }}
        />
      </span>
    </Popconfirm>
  )
}

export default MomentShareSwitch
